import styled from 'styled-components'
import { Image } from 'react-bootstrap'

export const Avatar = styled(Image)`
  position: absolute;
  display: inline-block;
  top: 10px;
  left: 15px;
  cursor: pointer;
  height: 50px;
  width: 50px;
  border-radius: 50%;
`

export const DropdownAvatar = styled.div`
  .btn-group {
    button {
      position: relative;
      background: transparent;
      box-shadow: none;
      width: 53px;
      height: 36px;
      padding: 0;
      border: none;
      &::before {
        content: '';
        background: ${props =>
          props.avatarUrl ? 'url(' + props.avatarUrl + ')' : '#fff'};
        background-size: cover;
        background-position: center;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        height: 36px;
        width: 36px;
        border: 1px solid ${props => props.theme.colors.dustyGray};
        border-radius: 50%;
      }
      .caret {
        display: block;
        position: absolute;
        top: 50%;
        transform: rotate(45deg) translateY(-50%);
        transform-origin: top;
        right: 0;
        width: 5px;
        height: 5px;
        opacity: 0.7;
        border: 1px solid ${props => props.theme.colors.white};
        border-width: 0 1px 1px 0;
      }
    }
  }
`
